/**
 * Formattazione numerica italiana: virgola per i decimali, punto per le
 * migliaia (41312.7 → "41.312,70").
 *
 * Prima ogni schermata se la cavava da sola e in una stessa pagina
 * convivevano tre convenzioni: `toFixed(2)` (formato inglese "41312.70"),
 * `toFixed(2).replace('.', ',')` (virgola ma senza migliaia) e
 * `toLocaleString('it-IT')`. Passare sempre da qui.
 *
 * ⚠️ SOLO PER VISUALIZZAZIONE. Non passare mai il risultato al `value` di un
 * <input>: il parse dei campi numerici si aspetta il punto decimale, con la
 * virgola il campo diventa impossibile da modificare. Per i campi editabili
 * resta `toFixed()`.
 */

const formatter = (decimals: number) =>
  new Intl.NumberFormat('it-IT', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

/** Numero puro: 41312.7 → "41.312,70" */
export function formatNumber(value: number | null | undefined, decimals = 2): string {
  const n = Number(value ?? 0);
  if (!Number.isFinite(n)) return formatter(decimals).format(0);
  return formatter(decimals).format(n);
}

/** Importo con simbolo: 41312.7 → "€ 41.312,70" */
export function formatEuro(value: number | null | undefined, decimals = 2): string {
  return `€ ${formatNumber(value, decimals)}`;
}

/** Importo arrotondato all'euro, per i riepiloghi compatti: → "€ 41.313" */
export function formatEuroRounded(value: number | null | undefined): string {
  return `€ ${formatNumber(Math.round(Number(value ?? 0)), 0)}`;
}

/** Superficie: 702 → "702,00 m²" */
export function formatArea(value: number | null | undefined, decimals = 2): string {
  return `${formatNumber(value, decimals)} m²`;
}
